<template>
  <div :class="cn('w-full', $attrs.class)">
    <!-- Tabs List -->
    <div class="segmented-tabs-scrollbar flex items-end justify-start gap-1 border-b border-foreground/20 pt-2 text-muted-foreground w-full overflow-x-auto">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        @click="$emit('update:modelValue', tab.value)"
        :class="[
          'relative -mb-px inline-flex min-w-max items-center justify-center whitespace-nowrap border border-transparent rounded-t-md px-4 py-2 text-sm ring-offset-background transition-all focus-visible:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
          modelValue === tab.value 
            ? 'z-10 border-x-foreground/20 border-t-foreground/20 border-b-background bg-background text-foreground font-semibold'
            : 'text-muted-foreground hover:bg-muted/40 hover:text-foreground font-medium'
        ]"
      >
        {{ tab.label }}
      </button>
    </div>
    
    <!-- Tab Content Area -->
    <div class="mt-4 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
      <slot />
    </div>
  </div>
</template>

<script>
import { cn } from "@/lib/utils";

export default {
  name: "SegmentedTabs",
  props: {
    modelValue: {
      type: String,
      required: true
    },
    tabs: {
      type: Array, // Array of { label: 'String', value: 'String' }
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup() {
    return { cn };
  }
};
</script>

<style scoped>
.segmented-tabs-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.segmented-tabs-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
